/*
Only responsible to append <script/> inside an iframe
Required: iframeId
*/
const getScriptForIframe = (url, scriptId, iframeId) => new Promise((resolve, reject) => {
    const iFrame = document.getElementById(iframeId);
    let framedoc = iFrame.contentDocument;
    if (!framedoc && iFrame.contentWindow) {
        framedoc = iFrame.contentWindow.document;
    }
    const script = framedoc.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = scriptId;
    framedoc.body.appendChild(script);
    if (window.ApexChat.nonceValue) {
        script.nonce = ApexChat.nonceValue
    }
    script.onload = script.onreadystatechange = function () {
        framedoc.body.removeChild(script);
        resolve(this);
    };
});
export default getScriptForIframe;
